import { useCallback, useState } from "react";
import type { ChangeEvent } from "react";

import toast from "react-hot-toast";

import { Button } from "simplydo/react/ui/button";
import { Divider } from "simplydo/react/ui/divider";
import { Form, FormField, FormGroup } from "simplydo/react/ui/form";
import { H3 } from "simplydo/react/ui/header";
import { Input } from "simplydo/react/ui/input";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";

import SettingActions from "../SettingActions";

const InitialProfileSetup = () => {
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();

  const [saving, setSaving] = useState(false);
  const [firstName, setFirstName] = useState(user?.profile?.firstName);
  const [lastName, setLastName] = useState(user?.profile?.lastName);

  const saveProfile = useCallback(() => {
    if (!user) return;
    setSaving(true);
    const profile = {
      ...user.profile,
      firstName: firstName ?? "",
      lastName: lastName ?? "",
    };
    api.users.update(
      user._id,
      { profile },
      (newUser) => {
        setSaving(false);
        dispatch(
          actions.user.receiveUser({ ...user, profile: newUser.profile }),
        );
      },
      (err) => {
        toast.error(err.message);
        setSaving(false);
      },
    );
  }, [firstName, lastName, user, dispatch]);

  return (
    <>
      <H3>You are about to join {user?.ownerOrganisation?.name}!</H3>
      <p>
        We just need to know a few more details about you. To continue, please
        let others know who you are.
      </p>
      <Form>
        <FormGroup widths="equal">
          <FormField
            control={Input}
            fluid
            label="First name"
            placeholder="First name"
            value={firstName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setFirstName(e.target.value)
            }
            autoComplete="given-name"
          />
          <FormField
            control={Input}
            fluid
            label="Last name"
            placeholder="Last name"
            value={lastName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setLastName(e.target.value)
            }
            autoComplete="family-name"
          />
        </FormGroup>
        <Divider hidden />
        <SettingActions>
          <Button
            onClick={saveProfile}
            loading={saving}
            disabled={!firstName || !lastName}
            color="primary"
          >
            Save profile
          </Button>
        </SettingActions>
      </Form>
    </>
  );
};

export default InitialProfileSetup;
